import shell from "../catalogues/en/shell.json" with { type: "json" };
import pickers from "../catalogues/en/pickers.json" with { type: "json" };
import markdown from "../catalogues/en/markdown.json" with { type: "json" };
import collection from "../catalogues/en/collection.json" with { type: "json" };
import item from "../catalogues/en/item.json" with { type: "json" };
import project from "../catalogues/en/project.json" with { type: "json" };
import inbox from "../catalogues/en/inbox.json" with { type: "json" };
import viewsNav from "../catalogues/en/viewsNav.json" with { type: "json" };
import bulkReport from "../catalogues/en/bulkReport.json" with { type: "json" };
import type { Catalogue } from "./catalogue.ts";

/**
 * The application's static catalogues (`research.md` W-26: the shell, the collection machinery,
 * the pickers, the item detail, the project screens, the inbox and the markdown surfaces), which
 * the application's entry imports from `@baton/i18n/app` and hands to `registerAppCatalogue`
 * before it renders. Nothing the sign-in or setup entries import reaches this module, so these
 * words count against the application's budget alone (2026-09-28, FR-015-120).
 */
export const appCatalogue: Catalogue = { ...shell, ...pickers, ...markdown, ...collection, ...item, ...project, ...inbox, ...viewsNav, ...bulkReport };
